/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateEventRequestData } from '../models/CreateEventRequestData';
import type { EditEventRequestData } from '../models/EditEventRequestData';
import type { EnrichedEventData } from '../models/EnrichedEventData';
import type { EventRecurrentEditRequestData } from '../models/EventRecurrentEditRequestData';
import type { SendMessageRequestData } from '../models/SendMessageRequestData';
import type { SlimEventData } from '../models/SlimEventData';
import type { UpdateEventCommentData } from '../models/UpdateEventCommentData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventService {
  /**
   * Create Event
   * @param requestBody
   * @returns EnrichedEventData Successful Response
   * @throws ApiError
   */
  public static createEvent(requestBody: CreateEventRequestData): CancelablePromise<Array<EnrichedEventData>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/event',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Edit Event
   * @param requestBody
   * @returns EnrichedEventData Successful Response
   * @throws ApiError
   */
  public static editEvent(requestBody: EditEventRequestData): CancelablePromise<EnrichedEventData> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/event',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Event
   * @param eventId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteEvent(eventId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/event',
      query: {
        event_id: eventId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Send Emails
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static sendEmails(requestBody: SendMessageRequestData): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/event/send_emails',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Event
   * @param eventId
   * @returns SlimEventData Successful Response
   * @throws ApiError
   */
  public static getSlimEvent(eventId: string): CancelablePromise<SlimEventData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/event/slim',
      query: {
        event_id: eventId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Recurrent Event
   * @param recurrentEventId
   * @param fromDate
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteEventRecurrent(recurrentEventId: string, fromDate: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/event/recurrent',
      query: {
        recurrent_event_id: recurrentEventId,
        from_date: fromDate,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Edit Recurrent Event
   * @param requestBody
   * @returns EnrichedEventData Successful Response
   * @throws ApiError
   */
  public static editEventRecurrent(
    requestBody: EventRecurrentEditRequestData,
  ): CancelablePromise<Array<EnrichedEventData>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/event/recurrent',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Event Comment
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static updateEventComment(requestBody: UpdateEventCommentData): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/event/comment',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
